import React from 'react';
import { Link as RouterLink } from 'react-router';
import { Link } from '@mui/material';

const TextLink = ({ text, to, variant, sx, ...props }) => (
  <Link
    to={to}
    variant={variant || 'body2'}
    component={RouterLink}
    sx={sx || {}}
    {...props}
  >
    {text}
  </Link>
);

export default TextLink;
